import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { IAFrustrationDataset } from './ia-frustration.models';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class IAFrustrationService {

    constructor(
        private cvAPIService: CVApiService
    ) { }

    async LoadFrustrationDatasets(moduleKey: string): Promise<Array<IAFrustrationDataset>> {
        const urlOptions = `${moduleKey}`;
        const url = "/api/v2/dashboards/modules/frustration/datasets/" + urlOptions;
        try {
            const response = await this.cvAPIService.get<Array<IAFrustrationDataset>>(url);
            if (response.status_code !== 200)
                throw response;
            return response.data;
        }
        catch (error) {
            const e = error;
            console.error("Failed getting frustration datasets.");
            throw error;
        }
    }

    // maybe make the second two parameters optional (two declarations in moduleFactory)
    async LoadFrustrationData(moduleKey: string, isAutoRefresh: boolean,
        isFirstLoad: boolean,
        selectedView: string,
        abort?: Promise<void>) {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvAPIService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }
        const urlOptions = `${moduleKey}?isAutoRefresh=${!!isAutoRefresh}&isFirstLoad=${!!isFirstLoad}&view=${selectedView}`;
        const url = "/api/v2/dashboards/modules/frustration/" + urlOptions;

        try {
            const response = await this.cvAPIService.get(url, renderEndpoint, abort);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data;
        } catch (error) {
            if (error?.code !== DOMException.ABORT_ERR) { // Abort error
                console.error("Failed getting frustration data.");
                throw error;
            }
        }
    }

    async LoadFrustrationDataForExport(moduleKey: string, format: string, view: string, isCxOne: boolean) {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvAPIService.getModuleRenderEndPoint(moduleKey);

        } catch (error) {
            console.error("Failed getting render endpoint");
            throw error;
        }
        const url = `/api/v2/dashboards/modules/frustration/${moduleKey}/export?format=${format}&view=${view}&isCXOne=${isCxOne}`;

        try {
            const response = await this.cvAPIService.get<string>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            else
                return response;
        } catch (error) {
            console.error("Failed getting frustration data for export.");
            throw error;
        }
    }
}
